import { GitContributors } from "/home/runner/work/dialtone/dialtone/node_modules/.pnpm/@vuepress+plugin-git@2.0.0-rc.112_typescript@5.9.3_vuepress@2.0.0-rc.24_@vuepress+bundl_68350955d54d4c76b9fac2a4b790eff4/node_modules/@vuepress/plugin-git/lib/client/components/GitContributors.js";

export default {
  enhance: ({ app }) => {
    app.component("GitContributors", GitContributors);
  },
};
